import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { TopEventsEventSportSectionWrapper } from 'src/main/cms/TopEvents/topEventsList/topEventsEventsSections/TopEventsSportSectionWrapper';
import { ListContainer, ListContentWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { EmptyListItem } from 'src/domains/layouts/shared/cms/list/listItems/EmptyListItem';
import { List as MovableList } from 'react-movable';
import { TopEventsSportsListState } from 'src/main/cms/TopEvents/topEventsList/TopEventsEventsList.state';

export const TopEventsEventsList = observer('TopEventsEventsList', () => {
    const {
        cmsState: { topEventsState },
        trpcClient,
    } = useAppStateContext();
    const [state] = useState(() => new TopEventsSportsListState(trpcClient, topEventsState));

    return (
        <ListContainer areLoading={topEventsState.isTopEventsEventsDataLoading}>
            {topEventsState.sportsArray.length === 0 ? (
                <EmptyListItem />
            ) : (
                <MovableList
                    values={topEventsState.sportsArray}
                    onChange={state.handleSportsOrder}
                    renderList={({ children, props, isDragged }): React.ReactNode => (
                        <ListContentWrapper
                            {...props}
                            isDragged={isDragged}
                        >
                            {children}
                        </ListContentWrapper>
                    )}
                    renderItem={({ value, props, isDragged }): JSX.Element | null => {
                        return (
                            <div
                                {...props}
                                style={{ ...props.style, zIndex: 'initial' }}
                            >
                                <TopEventsEventSportSectionWrapper
                                    key={value.id}
                                    sportData={value}
                                    isDragged={isDragged}
                                />
                            </div>
                        );
                    }}
                />
            )}
        </ListContainer>
    );
});
